export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';

// Material Master List
export const MATERIAL_MASTER_LIST_SUCCESS = 'MATERIAL_MASTER_LIST_SUCCESS';
export const MATERIAL_MASTER_LIST_FAIL = 'MATERIAL_MASTER_LIST_FAIL';

// Material Master Single Data
export const MATERIAL_MASTER_SINGLE_DATA_SUCCESS =
  'MATERIAL_MASTER_SINGLE_DATA_SUCCESS';
export const MATERIAL_MASTER_SINGLE_DATA_FAIL =
  'MATERIAL_MASTER_SINGLE_DATA_FAIL';

// Edit Material Master
export const EDIT_MATERIAL_MASTER_SUCCESS = 'EDIT_MATERIAL_MASTER_SUCCESS';
export const EDIT_MATERIAL_MASTER_FAIL = 'EDIT_MATERIAL_MASTER_FAIL';

// Material Master Design
export const MATERIAL_MASTER_DESIGN_SUCCESS = 'MATERIAL_MASTER_DESIGN_SUCCESS';
export const MATERIAL_MASTER_DESIGN_FAIL = 'MATERIAL_MASTER_DESIGN_FAIL';

//edit custom tables
export const EDIT_CUSTOM_TABLE_SUCCESS = 'EDIT_CUSTOM_TABLE_SUCCESS';
export const EDIT_CUSTOM_TABLE_FAIL = 'EDIT_CUSTOM_TABLE_FAIL';
//edit global filter configuration
export const EDIT_FILTER_CONFIGURATION_SUCCESS = 'EDIT_FILTER_CONFIGURATION_SUCCESS';
export const EDIT_FILTER_CONFIGURATION_FAIL = 'EDIT_FILTER_CONFIGURATION_FAIL';

// Create Material Master
export const CREATE_MATERIAL_MASTER_SUCCESS = 'CREATE_MATERIAL_MASTER_SUCCESS';
export const CREATE_MATERIAL_MASTER_FAIL = 'CREATE_MATERIAL_MASTER_FAIL';

// Delete Material Master
export const DELETE_MATERIAL_MASTER_SUCCESS = 'DELETE_MATERIAL_MASTER_SUCCESS';
export const DELETE_MATERIAL_MASTER_FAIL = 'DELETE_MATERIAL_MASTER_FAIL';

// Clear Material Design View
export const CLEAR_MATERIAL_DESIGN_VIEW = 'CLEAR_MATERIAL_DESIGN_VIEW';
